export default function Tag({ tag }) {
  if (!tag) return null;
  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        borderRadius: "4px",
        padding: "4px",
        background: "#FADBFF",
        color: "#C20AA3",
        textTransform: "uppercase",
        fontWeight: "700",
        fontSize: "16px",
        lineHeight: "18px",
        zIndex: "1",
      }}
    >
      {tag}
    </div>
  );
}
